'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class wpDeliverableModel extends ngDepModel
{
	a4_1_work_activities_deliv_type_other = false;
	a4_1_work_activities_deliv_type_other_value = '';

	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}

	afterSetup(data){
		this.a4_1_work_activities_deliv_type_other = (this.a4_1_work_activities_deliv_type_other > 0 || true === this.a4_1_work_activities_deliv_type_other);
	}

	getValue(name){
		switch(name){
			case 'a4_1_work_activities_deliv_level':
				return this.getClassifValue('a4_1_work_activities_deliv_level', 'dissemination_level');
			case 'a4_1_work_activities_deliv_type':
				if(this.a4_1_work_activities_deliv_type_other){
					return this.a4_1_work_activities_deliv_type_other_value;
				}
				return this.getClassifValue('a4_1_work_activities_deliv_type_id', 'deliverablestype');
			case 'indicator_id':
				return this.getClassifValue('indicator_id', 'auto_indicator');
			case 'a4_1_work_activities_deliv_due_date':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name]);
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
}
